import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

localStorage.removeItem("btp_token");

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
}

export const LEVEL_INFO = {
  facile: { label: "Facile", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  intermediaire: { label: "Intermédiaire", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  avance: { label: "Avancé", cls: "bg-orange-100 text-orange-800 border-orange-300" },
};

export const TRADES = ["Maçon", "Électricien", "Plombier", "Peintre", "Coffreur", "Carreleur", "Menuisier", "Chef de chantier", "Manœuvre"];

export const THEMES = ["Sécurité", "Outillage", "Matériaux", "Consignes", "Communication", "Planning"];

export function speak(text, rate = 1, slot = null) {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "fr-FR";
  u.rate = rate;
  const frVoices = window.speechSynthesis.getVoices().filter((v) => v.lang?.toLowerCase().startsWith("fr"));
  if (frVoices.length) u.voice = frVoices[slot == null ? 0 : slot % frVoices.length];
  if (slot != null) u.pitch = slot === 0 ? 0.8 : 1.25;
  window.speechSynthesis.speak(u);
  return u;
}
